import React from "react";
import { Radio, Form, Space } from "antd";
import { SourcingScope } from "../interface";

interface ScopeSelectorProps {
  value?: SourcingScope;
  onChange?: (value: SourcingScope) => void;
}

export const ScopeSelector: React.FC<ScopeSelectorProps> = ({ value, onChange }) => {
  return (
    <Form.Item
      label="Sourcing Scope"
      rules={[{ required: true, message: "Please select sourcing scope" }]}
    >
      <Radio.Group value={value} onChange={(e) => onChange?.(e.target.value)}>
        <Space direction="vertical">
          <Radio value={SourcingScope.NCB}>
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>NCB - National Competitive Bidding</div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                This bidding process restricts participation to suppliers and contractors from within the country
              </div>
            </Space>
          </Radio>
          <Radio value={SourcingScope.ICB}>
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>ICB - International Competitive Bidding</div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                This process opens up bidding to all eligible suppliers worldwide. It is typically used for very large projects that require specialized technology or expertise
              </div>
            </Space>
          </Radio>
        </Space>
      </Radio.Group>
    </Form.Item>
  );
};